import { httpClient } from "@/lib/http-client/http-client";
import {
  IEmailActivation,
  IOtpSend,
  IOtpVerify,
  IRefreshToken,
  IRegister,
  ISigninWithOauth
} from "../types/auth";
import { API_ROUTES } from "../../constants/api.routes";
import {
  IAuthMeResponse,
  ILoginResponse,
  IRefreshTokenResponse,
  ISigninAnonymousResponse
} from "../interface/responses/IAuthResponses";

class AuthService {
  constructor() {}

  public async otpSend(data: IOtpSend) {
    const response = await httpClient.post(API_ROUTES.Auth.OtpSend, data);
    return response;
  }

  public async signinWithOauth(data: ISigninWithOauth) {
    const response = await httpClient.post(
      API_ROUTES.Auth.SigninWithOauth,
      {
        email: data.email
      },
      {
        headers: {
          Authorization: `Bearer ${data.accessToken}`
        }
      }
    );
    return response;
  }

  public async register(data: IRegister) {
    const response = await httpClient.post(API_ROUTES.Auth.Register, data);
    return response;
  }

  public async otpVerify(data: IOtpVerify) {
    const response = await httpClient.post<ILoginResponse>(
      API_ROUTES.Auth.OtpVerify,
      data
    );
    return response;
  }

  public async emailActivation(data: IEmailActivation) {
    const response = await httpClient.post(
      API_ROUTES.Auth.EmailActivation,
      data
    );
    return response;
  }

  public async getMe() {
    const response = await httpClient.get<IAuthMeResponse>(API_ROUTES.Auth.Me);
    return response;
  }

  public async refreshToken(data: IRefreshToken) {
    const response = await httpClient.post<IRefreshTokenResponse>(
      API_ROUTES.Auth.RefreshToken,
      data
    );

    if (response.success) {
      localStorage.setItem("accessToken", response.data.accessToken);
    }
    return response;
  }

  public async signinAnonymous() {
    const response = await httpClient.post<ISigninAnonymousResponse>(
      API_ROUTES.Auth.SigninAnonymous
    );
    return response;
  }
}

export const authService = new AuthService();
export default new AuthService();

